import { Component, OnInit } from '@angular/core';
import { getAlertMessage } from '../../shared/api-loaders';
import { MessageService } from '../../shared/message.service';
import { MessageType } from '../../shared/messageType';
import { ModalService } from '../../shared/modal.service';
import { UserService } from '../../users/services/user.service';
import { TwoFactorResetConfirmtionDialogComponent } from '../two-factor-reset-confirmtion/two-factor-reset-confirmtion-dialog.component';

@Component({
    selector: 're-two-factor',
    templateUrl: './two-factor.component.html',
    styleUrls: ['./two-factor.component.scss'],
    standalone: false
})
export class TwoFactorComponent implements OnInit {

  constructor(private modalService: ModalService, private userService: UserService, private messageService: MessageService) { }

  ngOnInit(): void {
  }

  resettingFactor = false;
  async reset() {
    var dialog = this.modalService.create<TwoFactorResetConfirmtionDialogComponent>(TwoFactorResetConfirmtionDialogComponent);
    if (await dialog.modalRef.result) {
      this.resettingFactor = true;
      this.userService.resetMyFactors().subscribe(() => {
        this.messageService.send({ type: MessageType.FactorResetted, message: 'All factors have been reset' })
        this.resettingFactor = false;
      }, err => {
        this.messageService.send(getAlertMessage(err));
        this.resettingFactor = false;
      });
    }
  }
}
